import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QuoraIcon(props: IconProps) {
    return <Icon {...props} iconKey={"quora"}/>
}
